var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('configs-table',{on:{"click":_vm.handleConfigClick}}),(_vm.editor)?_c('action-button',{attrs:{"bottom":"","right":"","fixed":""},on:{"click":_vm.handleAddClick}},[_c('v-icon',[_vm._v("mdi-plus")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }